export const items = [
  {
    key: '1',
    label: '平台中免费功能有哪些？',
    children: (
      <div className='box'>
        <label>平台支持不限次免费生成标题、摘要、目录大纲，免费生成正文1.1小节，免费选择参考文献。</label>
      </div>
    )
  },
  {
    key: '2',
    label: '用户创作的内容安全性如何保证？',
    children: (
      <div className='box'>
        <label>
          本平台高度重视论文安全及用户隐私安全，全部内容数据均采用AES深度加密技术进行存储，数据传输采用SSL加密技术，严格保障内容数据安全。
        </label>
      </div>
    )
  },
  {
    key: '3',
    label: '在哪里查看生成的内容记录？',
    children: (
      <div className='box'>
        <label>使用本平台生成的所有内容均可通过【用户信息】-下拉菜单中【论文管理】查看、编辑及下载导出。</label>
      </div>
    )
  },
  {
    key: '4',
    label: '生成的论文查重率和AIGC率分别是多少？',
    children: (
      <div className='box'>
        <label>
          文果平台生成的内容可保证主流查重平台（知网、维普、万方）全文查重率低于15%，若高于承诺查重率则可联系客服退款。
        </label>
        <label>平台直接生成的内容AIGC率不能保证，正常多数在40%-60%。</label>
        <label>
          如果学校对AIGC率要求较高，推荐使用平台的智能降AIGC功能，可保证降后内容在主流检测平台（知网、维普、万方）全文AIGC率低于25%，若高于承诺AIGC率则可联系客服退字数/退款。
        </label>
      </div>
    )
  },
  {
    key: '5',
    label: '文献是真实的吗？能引用多少篇？支持外文文献吗？能用自己找的文献吗？',
    children: (
      <div className='box'>
        <label>
          平台直接关联知网真实文献，支持点击跳转知网官网查看原文信息，文献来源有据可查；同时支持关键词检索和知网查新引文格式批量上传本地文献；可选择的文献篇数无限制，每段落支持指定1~4篇参考文献；知网外文文献较少，建议自行查找后通过本地上传。
        </label>
      </div>
    )
  },
  {
    key: '6',
    label: '除文本外，生成的论文中可以支持插入表格、公式、代码、图表（图片）的内容吗？',
    children: (
      <div className='box'>
        <label>平台支持生成表格、公式、代码和图表（生成的公式都是latex格式的），暂不支持生成图片内容。</label>
      </div>
    )
  },
  {
    key: '7',
    label: 'AI生成内容是抄袭或网络检索的吗？版权归属如何划分？',
    children: (
      <div className='box'>
        <label>
          文果平台所有内容均属AI原创，并非检索得来；由于平台操作的高度灵活性和自由性，版权应属于实际使用平台操作生成内容的用户。
        </label>
      </div>
    )
  },
  {
    key: '8',
    label: '平台支持哪些论文？哪些专业？',
    children: (
      <div className='box'>
        <label>
          我们是专注大学论文的AI论文辅助创作平台，生成的论文是标准的大学毕业论文结构，支持大学课程论文、本科毕业论文、专科毕业论文。{' '}
        </label>
        <label>平台支持教育部发布的所有大学专业，选择专业时选择自己的专业大类即可，也可以在选题要求中另输入专业详细名称。</label>
      </div>
    )
  },
  {
    key: '9',
    label: '平台如何使用？可以提出哪些要求？',
    children: (
      <div className='box'>
        <label>文果平台不需本地部署，不需任何指令和提示词，选择相应功能，根据步骤提示操作即可。 </label>
        <label>
          可提出要求，如“使用xxxx的公式，代入值为100”、“代码需要实现xxxx功能”、“到xxx官网查找xxxx相关的真实数据，以表格样式呈现，并标明真实的数据来源”等，所有要求描述均直接使用结合专业学科术语的通俗表达，没有固定格式，详细表达可参考选题要求或段落要求输入框中灰字提示。
        </label>
      </div>
    )
  },
  {
    key: '10',
    label: '平台使用的AI模型有何优势？',
    children: (
      <div className='box'>
        <label>
          平台中所有AI内容生成功能均采用全球领先的GPT-5
          强化模型，其理解度、准确性、连贯性、推理能力、辩证能力、数据分析能力均保持国际领先水平。
        </label>
      </div>
    )
  },
  {
    key: '11',
    label: '平台有哪些功能？有哪些亮点？',
    children: (
      <div className='box'>
        <label>
          文果是专注于大学毕业论文的AI辅助创作平台。平台支持开题报告、文献综述、课程论文、毕业论文、答辩PPT、段落修改、降重降AIGC、格式排版等功能，详情见首页顶栏。
        </label>
        <label>平台亮点：</label>
        <label>①使用国际领先AI大模型GPT-5，更高的内容质量；</label>
        <label>②关联知网真实文献，支持点击跳转知网官网查看原文信息，文献来源有据可查；</label>
        <label>③不限次数免费生成目录大纲，论文内容提前知晓，支持无限改稿，高度自由化操作；</label>
        <label>④支持一键全文和逐段成文两种成文模式，操作灵活，内容更可控；</label>
        <label>⑤支持对段落指定文献和插入生成图表、表格、公式、代码，并针对以上功能提出详细要求，内容形式更丰富</label>
        <label>⑥平台内容均支持在线编辑，包括选题/摘要/目录大纲/正文/图表/表格/公式/代码等</label>
        <label>⑦拥有海量答辩PPT模板，自动生成，支持在线调整</label>
      </div>
    )
  },
  {
    key: '12',
    label: '平台是否可以代写？',
    children: (
      <div className='box'>
        <label>我们是论文辅助创作平台，不提供代写服务。</label>
      </div>
    )
  },
  {
    key: '13',
    label: '生成一篇完整的论文全文需要多久？',
    children: (
      <div className='box'>
        <label>
          平台所有的文本类功能均使用国际领先的AI模型技术支持，万字生成最快约2分钟。如遇特殊情况可能会延迟，若同时购买了其它增值服务，生成时间也可能延长，请同学耐心等待即可。
        </label>
      </div>
    )
  },
  {
    key: '14',
    label: '能否生成外文论文？可以写哪些语种？',
    children: (
      <div className='box'>
        <label>平台支持生成外文论文，语种支持中、英、俄、德、法、韩、日、泰。</label>
      </div>
    )
  },
  {
    key: '15',
    label: ' 字数/券使用如何计算？',
    children: (
      <div className='box'>
        <label>
          使用文果平台生成毕业论文、课程论文、开题报告、文献综述、格式排版以及答辩PPT均以篇/份计；仅在使用降重、降AIGC功能时，以AI生成前的对应原文/原段落字数计。
        </label>
        <label>消耗字数前用户需要根据弹窗提示进行二次确认，字数消耗记录可在用户信息下拉菜单【个人中心】中查看。</label>
        <label>
          字数/券计算规则：1 个汉字计 1 字数；1 个英文单词计 1 字数。不同券种仅用于相关内容生成，1
          份PPT或1篇开题报告即对应1张PPT券或开题报告券。
        </label>
      </div>
    )
  },
  {
    key: '16',
    label: '字数/券使用后能否退款？',
    children: (
      <div className='box'>
        <label>
          平台提供论文辅助创作服务，区别于代写服务，且平台支持无限改稿，用户可自主灵活使用，故不支持以“生成内容不满意”“写的不符合要求”为理由的退款；若因平台故障等导致无法继续使用，可支持退款。退款问题可添加客服咨询处理。
        </label>
        <label>
          用户以活动优惠价购买套餐的，套餐内容使用后，非平台原因不支持全额退款；如需退款，平台可支持根据实际使用情况折算后退差价部分，若差价未负数金额，则无法退款。
        </label>
        <label>折算规则示例：</label>
        <label>套餐价格100元，套餐包含开题报告（下单时正价39元）、毕业论文（正价69元）、答辩PPT（正价49元）三项服务内容。</label>
        <label>若用户仅单独使用了开题报告后申请退款，则退款金额为：100-39=61元；</label>
        <label>若用户使用了开题报告和毕业论文后申请退款，则退款金额为：100-39-69=-8元，即不支持退款。</label>
      </div>
    )
  },
  {
    key: '17',
    label: '生成内容不满意能否重新生成？',
    children: (
      <div className='box'>
        <label>平台支持无限改稿。无限改稿仅支持针对二级以上标题、段落主旨及正文内容进行修改，一级标题确定后不支持修改。</label>
      </div>
    )
  },
  {
    key: '18',
    label: '能否根据自己的开题报告/大纲生成？',
    children: (
      <div className='box'>
        <label>
          若已经有开题报告，可在第一步「基本信息」通过【参考资料】按钮上传；若已有大纲可以通过第四步「目录大纲」通过【我的要求】手动输入。
        </label>
      </div>
    )
  },
  {
    key: '19',
    label: '可以对段落指定文献吗？不指定文献正文生成会参考文献吗？/大纲生成？',
    children: (
      <div className='box'>
        <label>我们支持对段落指定文献和自动关联文献两种形式：</label>
        <label>
          1.指定文献，可在第五步「论文正文」通过目录大纲选定段落，在需要指定文献的段落章节标题处点亮文献标记，并选择需要指定的文献；
        </label>
        <label>2.自动关联文献，在全文未指定任何文献时生成，会开启智能关联文献功能。</label>
        <label>以上操作生成的正文可显示文献角标。</label>
      </div>
    )
  },
  {
    key: '20',
    label: '如何在正文中生成表格、公式、代码、图表吗？',
    children: (
      <div className='box'>
        <label>
          在目录中对应段落章节标题右侧点亮相应功能图标-点击章节标题左侧「生成段落/重新生成」按钮-提出详细段落要求或上传相应参考图-点击「开始生成」按钮确认生成。
        </label>
      </div>
    )
  },
  {
    key: '21',
    label: '如何在正文生成数据？',
    children: (
      <div className='box'>
        <label>有数据可提供你的数据： </label>
        <label>①通过文字提供：生成段落】-通过文字加数字输入数据信息，给到详细要求】； </label>
        <label>②通过图片上传：生成段落】-上传数据截图、设计稿、spss分析结果截图等。 </label>
        <label>没有数据的，可以通过对段落提出要求让AI帮你到指定平台/数据库查找真实数据，并标记数据来源： </label>
        <label>生成段落】-根据需要输入详细要求，如，“到中国海关总署官网查找xxxxx真实数据，并标明数据来源”。 </label>
        <label>如无要求真实数据，不能完全保证AI生成数据的真实性。</label>
      </div>
    )
  },
  {
    key: '22',
    label: '生成的论文字数为什么和选择的字数有出入？',
    children: (
      <div className='box'>
        <label>
          正文生成字数与目录丰富度紧密相关，内容均由大模型生成，非平台技术可精准控制，选择全文字数仅对大范围限制，无法精确到具体字数，可通过增删目录章节调节全文字数。
        </label>
      </div>
    )
  },
  {
    key: '23',
    label: '搜到的文献都是近期的吗？',
    children: (
      <div className='box'>
        <label>
          文献根据关键词检索而来，查找到的文献过少、过老可能是关键词过多过长或者有生僻词，可以返回修改关键词重新检索，也可通过本地上传合适的文献。{' '}
        </label>
      </div>
    )
  },
  {
    key: '24',
    label: '导出是word文档吗？论文是什么格式？',
    children: (
      <div className='box'>
        <label>导出全文导出的是“.docx”格式文档文件，可以在Word或WPS中打开继续编辑。</label>
        <label>因各院校对论文格式的要求无统一标准，平台采取固定基础样式，若有需要可使用平台的【格式排版】功能。 </label>
      </div>
    )
  },
  {
    key: '25',
    label: '生成段落/逐段生成是否会影响成文质量？是否会上下文不连贯？',
    children: (
      <div className='box'>
        <label>
          平台经过大量的测试，为用户集成上千提示词，可精准根据用户提出的详细要求生成内容，并保持内容语句通顺、逻辑连贯、上下文衔接流畅且带有学术性质等。
        </label>
      </div>
    )
  },
  {
    key: '26',
    label: '输入相同的选题，再次生成的内容会相同吗？',
    children: (
      <div className='box'>
        <label>平台经过了大量的模型训练，相同的选题二次或者多次提交，都可以随机生成不同的内容。 </label>
      </div>
    )
  },
  {
    key: '27',
    label: '范文中的正文可以和引用的参考文献完全对应吗？',
    children: (
      <div className='box'>
        <label>
          引用分为“直接引用”和“间接引用”。文果平台为保证文章的原创性，采取的是“间接引用”的算法，即AI通过自己的算法转述所引用的参考文献内容，并重新组织语言表达，所以并不能和所引用的参考文献中的原语句一模一样。
        </label>
      </div>
    )
  }
]
